import React, { useState } from 'react'
import SelectField from '../common/SelectField'
import PlanMetadataFields from './FieldGroups/PlanMetadataFields'
import StatesFields from './FieldGroups/StatesFields'
import CarrierBrandFields from './FieldGroups/CarrierBrandFields'
import IssuersFields from './FieldGroups/IssuersFields'
import LineOfCoverageFields from './FieldGroups/LineOfCoverageFields'

type MatchingTypeOption = { text: string, value: string }

type Props = {
  handleChange: (field: string, value: string) => void,
  updateMatchingData: (field: string, value: string) => void,
  matchingTypes: MatchingTypeOption[],
  matchingDataFields: Array<string>
  values: {
    [key: string]: string
  }
}

const MatchingDataFields: React.FC<Props> = ({
  matchingTypes,
  matchingDataFields,
  values,
  updateMatchingData,
  handleChange
}) => {
  const [matchingType, setMatchingType] = useState(values.matching_type)

  const fields = [...matchingDataFields, 'matching_data']

  const onChange = (field: string, value: string) => {
    setMatchingType(value)
    handleChange(field, value)
    // eslint-disable-next-line no-param-reassign
    fields.forEach((key) => { delete (values[key]) })
  }

  const showMatchingDataFields = () => {
    switch (matchingType) {
    case 'plan_metadata':
      return <PlanMetadataFields handleChange={updateMatchingData} values={values} />
    case 'states':
      return <StatesFields handleChange={updateMatchingData} values={values} />
    case 'carrier_brand_name':
      return <CarrierBrandFields handleChange={updateMatchingData} values={values} />
    case 'issuers':
      return <IssuersFields handleChange={updateMatchingData} values={values} />
    default:
      return null
    }
  }

  return (
    <fieldset>
      <SelectField
        name="matching_type"
        label="Matching Type"
        handleChange={onChange}
        options={matchingTypes}
        value={matchingType}
      />

      {matchingType && <LineOfCoverageFields handleChange={updateMatchingData} values={values} />}

      {showMatchingDataFields()}
    </fieldset>
  )
}

export default MatchingDataFields
